module.exports = __webpack_public_path__ + "img/class-room-list-bannerImg.91ebf997.jpg";